import * as React from 'react';
import { Form, Input, Button } from 'antd';
import I18N from 'src/services/I18NService';
import { FormComponentProps } from 'antd/lib/form';
import { IMallPharmacySearch } from 'src/entity/MallEntity';

interface IPharmacySearchProps extends FormComponentProps {
  cbSearch(query: IMallPharmacySearch): Promise<void>;
}

interface IPharmacySearchState {
  isClick: boolean;
}

class PharmacySearch extends React.Component<IPharmacySearchProps, IPharmacySearchState> {
  constructor(props: IPharmacySearchProps) {
    super(props);

    this.state = {
      isClick: false,
    };
  }

  /**
   * 查询
   *
   * @memberof PharmacySearch
   */
  handleSearch = (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (this.state.isClick) {
      return;
    }
    this.setState({
      isClick: true,
    });
    this.props.form.validateFields(async (err, values: IMallPharmacySearch) => {
      if (!err) {
        const query: IMallPharmacySearch = {
          name: values.name,
          is_deleted: false,
          offset: 0,
          limit: 10,
        };

        await this.props.cbSearch(query);
      }

      this.setState({
        isClick: false,
      });
    });
  };

  /**
   * 重置
   *
   * @memberof PharmacySearch
   */
  handleReset = () => {
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form layout="inline" className="mall-pharmacy-search" onSubmit={this.handleSearch}>
        <Form.Item label={I18N.get('pharmacy_name')}>
          {getFieldDecorator(`name`)(<Input style={{ width: '300px' }} placeholder={I18N.get('pharmacy_name')} />)}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {I18N.get('common_search')}
          </Button>
          &nbsp;&nbsp;
          <Button onClick={this.handleReset}>{I18N.get('common_clear')}</Button>
        </Form.Item>
      </Form>
    );
  }
}

const PharmacySearchForm = Form.create<IPharmacySearchProps>()(PharmacySearch);
export default PharmacySearchForm;



// WEBPACK FOOTER //
// ./src/components/views/Mall/PharmacySearchForm.tsx